import * as apiDelete from 'api/tagCategory/DeleteTagCategoryIdV1';
import * as apiRestore from 'api/tagCategory/PostTagCategoryRestoreV1';
import * as apiPostSearch from 'api/tagCategory/PostTagCategorySearchV1';

export default class TagCategory {
	public id: string = '';
	public name: string = '';

	public constructor(input?: apiPostSearch.ResponseTagCategory) {
		if (input) {
			this.mapFromApi(input);
		}
	}

	public async callApiDelete(): Promise<void> {
		await apiDelete.callApi(this.id);
	}

	public async callApiRestore(): Promise<void> {
		await apiRestore.callApi(this.id);
	}

	private mapFromApi(input: apiPostSearch.ResponseTagCategory) {
		this.id = input.id;
		this.name = input.name;
	}
}
